var $ = require('jquery');

var self = {};

self.initialise = function() {
  $(document).ready(function() {
    $('.inxpress-country .media__img img').click(function() {
      window.location.href = $(this)
        .next('.panel-text')
        .find('.btn--trans')
        .attr('href');
    });
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/country-media.js